import React from "react";
import { EMPTY_OBJ } from "../helpers/logic/empties";
import { FLOATING_ELEMENT_SIDE_OFFSET } from "./constants";
import useDropdownMenuItems from "./hooks/useDropdownMenuItems";
import useTrigger from "./hooks/useTrigger";
import { BaseDropdown, Content, Trigger } from "./styled";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function DropdownMenu(_ref) {
  var items = _ref.items,
    trigger = _ref.trigger,
    _ref$preferredAlignme = _ref.preferredAlignment,
    preferredAlignment = _ref$preferredAlignme === void 0 ? "start" : _ref$preferredAlignme,
    disabled = _ref.disabled;
  var _ref2 = trigger || EMPTY_OBJ,
    _ref2$type = _ref2.type,
    type = _ref2$type === void 0 ? "button" : _ref2$type,
    props = _ref2.props;
  var triggerComponent = useTrigger(type, props, disabled);
  var dropdownMenuComponents = useDropdownMenuItems(items);
  return /*#__PURE__*/_jsxs(BaseDropdown, {
    modal: false,
    children: [/*#__PURE__*/_jsx(Trigger, {
      disabled: disabled,
      asChild: true,
      children: triggerComponent
    }), /*#__PURE__*/_jsx(Content, {
      align: preferredAlignment,
      sideOffset: FLOATING_ELEMENT_SIDE_OFFSET,
      children: dropdownMenuComponents
    })]
  });
}
DropdownMenu.displayName = "DropdownMenu";
export default DropdownMenu;